import styled from 'styled-components';
import { cssVars } from '../../../shared/lib/styledTheme';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: ${cssVars.bgColor};
  border-radius: 12px;
  width: 90%;
  max-width: 900px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  color: ${cssVars.textSecondary};
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
  }
`;

export const SearchInput = styled.input`
  margin: 16px 24px;
  padding: 12px 16px;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 8px;
  background-color: ${cssVars.bgSecondary};
  color: ${cssVars.textPrimary};
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: ${cssVars.primary};
    box-shadow: 0 0 0 3px ${cssVars.primary}10;
  }

  &::placeholder {
    color: ${cssVars.textTertiary};
  }
`;

export const TemplatesContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const TemplatesList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 8px 24px 24px;
  border-right: 1px solid ${cssVars.borderColor};
`;

export const TemplateItem = styled.div<{ $selected?: boolean }>`
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 8px;
  background-color: ${props => props.$selected ? cssVars.selected : cssVars.bgSecondary};
  border: 1px solid ${props => props.$selected ? cssVars.primary : cssVars.borderColor};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${props => props.$selected ? cssVars.selected : cssVars.hover};
    border-color: ${cssVars.primary};
  }
`;

export const TemplateName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin-bottom: 8px;
`;

export const TemplatePreview = styled.div`
  font-size: 13px;
  color: ${cssVars.textSecondary};
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const TemplatePreviewPanel = styled.div`
  width: 350px;
  padding: 24px;
  background-color: ${cssVars.bgSecondary};
  display: flex;
  flex-direction: column;
`;

export const PreviewTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin-bottom: 12px;
`;

export const PreviewContent = styled.div`
  flex: 1;
  padding: 16px;
  background-color: ${cssVars.bgColor};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 8px;
  font-size: 14px;
  color: ${cssVars.textPrimary};
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-y: auto;
  margin-bottom: 16px;
`;

export const InsertButton = styled.button`
  padding: 12px 24px;
  background-color: ${cssVars.primary};
  color: ${cssVars.white};
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${cssVars.primaryHover};
  }
`;

export const EmptyText = styled.div`
  padding: 24px;
  text-align: center;
  color: ${cssVars.textTertiary};
`;




